module.exports = __webpack_public_path__ + "img/2.4ddf4e7c.png";